import React from 'react'
import AnimatedContainer from '../AnimatedContainer/AnimatedContainer'

const AnimatedPageContainer = ({ children }) => (
    <AnimatedContainer animatedContainerId="page" containerClassName="page">
        {children}
    </AnimatedContainer>
)
        
export default AnimatedPageContainer